/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 *
 * @author	Yann Massard, yamass@gmail.com
 * @author	Matthias Bernstein, matthias.bernstein@data-centrics.com
 */
export const typescriptDeclarationFixConstant = 1;

import {UiEvent} from "./UiEvent";
import {TeamAppsEventListener} from "../modules/util/TeamAppsEvent";

export class EventRegistrator {
	public static registerForEvents(eventSource: any, type: string, eventHandler: TeamAppsEventListener<UiEvent>) {
		switch (type) {
			case "UiDummyComponent":
					 eventSource.onClicked && eventSource.onClicked.addListener(eventHandler);
				break;
			case "UiCalendar":
					 eventSource.onDataNeeded && eventSource.onDataNeeded.addListener(eventHandler);
					 eventSource.onViewChanged && eventSource.onViewChanged.addListener(eventHandler);
					 eventSource.onDayClicked && eventSource.onDayClicked.addListener(eventHandler);
					 eventSource.onEventMoved && eventSource.onEventMoved.addListener(eventHandler);
					 eventSource.onEventClicked && eventSource.onEventClicked.addListener(eventHandler);
				break;
			case "UiContextMenu":
					 eventSource.onContextMenuSelection && eventSource.onContextMenuSelection.addListener(eventHandler);
				break;
			case "UiGridForm":
					 eventSource.onFieldEvent && eventSource.onFieldEvent.addListener(eventHandler);
					 eventSource.onFieldValueChanged && eventSource.onFieldValueChanged.addListener(eventHandler);
					 eventSource.onSectionCollapsedStateChanged && eventSource.onSectionCollapsedStateChanged.addListener(eventHandler);
					 eventSource.onSubmitted && eventSource.onSubmitted.addListener(eventHandler);
				break;
			case "UiImageDisplay":
					 eventSource.onImageDisplayed && eventSource.onImageDisplayed.addListener(eventHandler);
					 eventSource.onImagesRequest && eventSource.onImagesRequest.addListener(eventHandler);
				break;
			case "UiImageCropper":
					 eventSource.onCropFrameChanged && eventSource.onCropFrameChanged.addListener(eventHandler);
				break;
			case "UiInfiniteItemView":
					 eventSource.onItemClicked && eventSource.onItemClicked.addListener(eventHandler);
					 eventSource.onDataRequest && eventSource.onDataRequest.addListener(eventHandler);
				break;
			case "UiItemView":
					 eventSource.onItemClicked && eventSource.onItemClicked.addListener(eventHandler);
				break;
			case "UiSplitPane":
					 eventSource.onResized && eventSource.onResized.addListener(eventHandler);
				break;
			case "UiLiveStreamComponent":
					 eventSource.onResultOfGetFlashPlayerVersion && eventSource.onResultOfGetFlashPlayerVersion.addListener(eventHandler);
					 eventSource.onResultOfRequestInputDeviceInfo && eventSource.onResultOfRequestInputDeviceInfo.addListener(eventHandler);
					 eventSource.onResultOfRequestInputDeviceAccess && eventSource.onResultOfRequestInputDeviceAccess.addListener(eventHandler);
				break;
			case "UiRtmpLiveStreamPlayer":
					 eventSource.onResultOfGetFlashPlayerVersion && eventSource.onResultOfGetFlashPlayerVersion.addListener(eventHandler);
				break;
			case "UiMap":
					 eventSource.onZoomLevelChange && eventSource.onZoomLevelChange.addListener(eventHandler);
				break;
			case "UiMediaTrackGraph":
					 eventSource.onHandleTimeSelection && eventSource.onHandleTimeSelection.addListener(eventHandler);
				break;
			case "UiVideoPlayer":
					 eventSource.onPlayerProgress && eventSource.onPlayerProgress.addListener(eventHandler);
					 eventSource.onErrorLoading && eventSource.onErrorLoading.addListener(eventHandler);
				break;
			case "UiNavigationBar":
					 eventSource.onButtonClicked && eventSource.onButtonClicked.addListener(eventHandler);
				break;
			case "UiNetworkGraph":
					 eventSource.onHandleNodeClick && eventSource.onHandleNodeClick.addListener(eventHandler);
				break;
			case "UiPanel":
					 eventSource.onFieldEvent && eventSource.onFieldEvent.addListener(eventHandler);
					 eventSource.onFieldValueChanged && eventSource.onFieldValueChanged.addListener(eventHandler);
					 eventSource.onToolButtonDropDownItemClicked && eventSource.onToolButtonDropDownItemClicked.addListener(eventHandler);
					 eventSource.onToolButtonClicked && eventSource.onToolButtonClicked.addListener(eventHandler);
				break;
			case "UiWindow":
					 eventSource.onToolButtonDropDownItemClicked && eventSource.onToolButtonDropDownItemClicked.addListener(eventHandler);
					 eventSource.onToolButtonClicked && eventSource.onToolButtonClicked.addListener(eventHandler);
				break;
			case "UiTable":
					 eventSource.onFieldEvent && eventSource.onFieldEvent.addListener(eventHandler);
					 eventSource.onFieldValueChanged && eventSource.onFieldValueChanged.addListener(eventHandler);
					 eventSource.onFooterFieldEvent && eventSource.onFooterFieldEvent.addListener(eventHandler);
					 eventSource.onFooterFieldValueChanged && eventSource.onFooterFieldValueChanged.addListener(eventHandler);
					 eventSource.onHeaderFieldEvent && eventSource.onHeaderFieldEvent.addListener(eventHandler);
					 eventSource.onHeaderFieldValueChanged && eventSource.onHeaderFieldValueChanged.addListener(eventHandler);
					 eventSource.onColumnSizeChange && eventSource.onColumnSizeChange.addListener(eventHandler);
					 eventSource.onFieldOrderChange && eventSource.onFieldOrderChange.addListener(eventHandler);
					 eventSource.onRequestNestedData && eventSource.onRequestNestedData.addListener(eventHandler);
					 eventSource.onTableDataRequest && eventSource.onTableDataRequest.addListener(eventHandler);
					 eventSource.onSortingChanged && eventSource.onSortingChanged.addListener(eventHandler);
					 eventSource.onMultipleRowsSelected && eventSource.onMultipleRowsSelected.addListener(eventHandler);
					 eventSource.onRowSelected && eventSource.onRowSelected.addListener(eventHandler);
					 eventSource.onCellEditingStopped && eventSource.onCellEditingStopped.addListener(eventHandler);
					 eventSource.onCellEditingStarted && eventSource.onCellEditingStarted.addListener(eventHandler);
				break;
			case "UiTabPanel":
					 eventSource.onToolButtonDropDownItemClicked && eventSource.onToolButtonDropDownItemClicked.addListener(eventHandler);
					 eventSource.onToolButtonClicked && eventSource.onToolButtonClicked.addListener(eventHandler);
					 eventSource.onTabClosed && eventSource.onTabClosed.addListener(eventHandler);
					 eventSource.onTabNeedsRefresh && eventSource.onTabNeedsRefresh.addListener(eventHandler);
					 eventSource.onTabSelected && eventSource.onTabSelected.addListener(eventHandler);
				break;
			case "UiTimeGraph":
					 eventSource.onIntervalSelected && eventSource.onIntervalSelected.addListener(eventHandler);
					 eventSource.onZoomed && eventSource.onZoomed.addListener(eventHandler);
					 eventSource.onDataNeeded && eventSource.onDataNeeded.addListener(eventHandler);
				break;
			case "AbstractUiToolContainer":
					 eventSource.onToolbarDropDownItemClick && eventSource.onToolbarDropDownItemClick.addListener(eventHandler);
					 eventSource.onToolbarButtonClick && eventSource.onToolbarButtonClick.addListener(eventHandler);
				break;
			case "UiToolbar":
					 eventSource.onToolbarDropDownItemClick && eventSource.onToolbarDropDownItemClick.addListener(eventHandler);
					 eventSource.onToolbarButtonClick && eventSource.onToolbarButtonClick.addListener(eventHandler);
				break;
			case "UiToolAccordion":
					 eventSource.onToolbarDropDownItemClick && eventSource.onToolbarDropDownItemClick.addListener(eventHandler);
					 eventSource.onToolbarButtonClick && eventSource.onToolbarButtonClick.addListener(eventHandler);
				break;
			case "UiTree":
					 eventSource.onRequestTreeData && eventSource.onRequestTreeData.addListener(eventHandler);
					 eventSource.onNodeSelected && eventSource.onNodeSelected.addListener(eventHandler);
				break;
			case "UiWorkSpaceLayout":
					 eventSource.onViewsMaximized && eventSource.onViewsMaximized.addListener(eventHandler);
					 eventSource.onViewsRestored && eventSource.onViewsRestored.addListener(eventHandler);
					 eventSource.onViewsMinimized && eventSource.onViewsMinimized.addListener(eventHandler);
					 eventSource.onViewTabClosed && eventSource.onViewTabClosed.addListener(eventHandler);
					 eventSource.onViewTabSelected && eventSource.onViewTabSelected.addListener(eventHandler);
					 eventSource.onChildWindowClosed && eventSource.onChildWindowClosed.addListener(eventHandler);
					 eventSource.onChildWindowCreationFailed && eventSource.onChildWindowCreationFailed.addListener(eventHandler);
					 eventSource.onViewNeedsRefresh && eventSource.onViewNeedsRefresh.addListener(eventHandler);
					 eventSource.onViewDraggedToNewWindow && eventSource.onViewDraggedToNewWindow.addListener(eventHandler);
					 eventSource.onLayoutChanged && eventSource.onLayoutChanged.addListener(eventHandler);
				break;
			case "UiSingleRecordFieldContainer":
					 eventSource.onFieldValueChanged && eventSource.onFieldValueChanged.addListener(eventHandler);
					 eventSource.onFieldEvent && eventSource.onFieldEvent.addListener(eventHandler);
				break;
			case "UiMultiRecordFieldContainer":
					 eventSource.onFieldValueChanged && eventSource.onFieldValueChanged.addListener(eventHandler);
					 eventSource.onFieldEvent && eventSource.onFieldEvent.addListener(eventHandler);
				break;
		}
	}
}